
import XdocProjectForPDF from '../components/XdocProjectForPDF.vue'
import { ServiceContentEnum } from '@/business/ServiceContent'
import { Component, Vue, Watch } from 'vue-property-decorator'
import BasePage from '../BasePage.vue'
import { editOrder } from '@/api/placeOrder'
import { IServiceMap } from '@/business/BusinessFormData'
import { IFormMap } from '@/store/modules/formMap'
import { IOrganization, ICustomerAppKey } from '@/store/state'
import { IOrderForm } from '@/types/placeOrderTypes'
import { Getter } from 'vuex-class'
import _ from 'lodash'
import { getDefaultForm } from '../helper'
import BasicInfo from '../components/BasicInfo.vue'
import UploadMaterial from '../components/Upload/UploadMaterial.vue'

@Component({
  components: {
    BasePage,
    BasicInfo,
    UploadMaterial,
    XdocProjectForPDF,
  },
})
export default class PdfImgToDocx extends Vue {
  @Getter('order_id') order_id!: string
  @Getter('organization') organization!: IOrganization
  @Getter('customerAppKey') customerAppKey!: ICustomerAppKey
  @Getter('formMap')
  formMap!: IFormMap

  defaultForm: IOrderForm = {} as IOrderForm
  form: IOrderForm = {} as IOrderForm
  formInfo: null | IServiceMap = null
  regBookName = false

  type = ''
  name = ''
  reEdit = false

  // 是否展示交付物选项
  show = false

  needWord = false
  needFbd = false
  selectedFbd = false
  selectedTab = 'pdf'

  @Watch('form.material', { deep: true })
  createXdocPlanning() {
    if (!this.form.material) return
    if (this.form.material.oss_pdf_files.length > 0) this.show = true
    if (this.form.material.type === 3 && this.form.material.oss_pdf_files.length) {
      this.form.xdoc_planning = [
        {
          name: this.form.alias,
          config: {
            delivery: 1,
          },
          origin_files: this.form.material.oss_pdf_files.map(item => {
            return {
              name: item.name,
              type: 1,
            }
          }),
          is_del: false,
        },
      ]
    }
  }

  get ServiceContentEnum() {
    return ServiceContentEnum
  }

  BaseMounted(serviceType: string, name: string) {
    this.type = serviceType
    this.name = name
    this.formInfo = this.formMap.formMap![serviceType]
    this.defaultForm = getDefaultForm(serviceType, this.formInfo, this.organization, this.customerAppKey, name)
  }
  FormChange(form: IOrderForm) {
    this.form = form
  }
  creatCheckForm(form: IOrderForm) {
    if (!form.book_name) return this.$message.error('请输入图书名称')
    if (!form.alias) return this.$message.error('请输入工单别名')
    if (!form.subject) return this.$message.error('请选择学科')
    if (!form.stage) return this.$message.error('请选择学段')
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.book_name)) {
      this.regBookName = true
      return this.$message.error('图书名称含有非法字符')
    }
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.alias)) {
      return this.$message.error('工单别名含有非法字符')
    }
  }

  submitCheckForm(bounds: any, callback: (val: boolean) => void) {
    // 文件检查
    if (this.form.material.type === 2 && !this.form.material.oss_images?.length)
      return this.$message.error('请上传图片文件')
    else if (this.form.material.type === 3 && !this.form.material.oss_pdf_files?.length)
      return this.$message.error('请上传pdf文件')

    if (this.type === 'pdfImgToDocxTool') {
      if (!this.needWord && !this.needFbd) {
        this.$message.warning('请至少选择一个交付内容')
        return callback(true)
      }

      // 如果输出格式为fbd，判断用户是否选择了模板
      if (this.needFbd) {
        const { config } = this.form.xdoc_planning[0]
        if (!config.style_id) {
          this.$message.error('请选择制作模板')
          return callback(true)
        }
      }
    }

    return callback(false)
  }

  async handleTabChange(tab: any) {
    // 先创建新的对象
    const newForm = _.cloneDeep(this.form)

    // 更新新对象的值
    newForm.material.type = tab === 'img' ? 2 : 3
    if (this.type === 'pdfImgToDocxTool') {
      newForm.service_content = tab === 'img' ? 4 : 24
    } else {
      newForm.service_content = tab === 'img' ? 2 : 9
    }

    if (tab === 'img') {
      newForm.material.oss_pdf_files = []
    } else {
      newForm.material.oss_images = []
    }

    this.form = newForm
  }

  async handleSaveForm() {
    await editOrder({ ticket_id: this.order_id, ...this.screenForm(this.form) })
  }

  handleSelectedLibrary() {
    this.selectedFbd = true
  }

  async submit(formData: any) {
    if (formData.xdoc_planning) {
      // 定义交付类型映射
      const deliveryType = this.needWord && this.needFbd ? 21 : this.needFbd ? 4 : 1

      formData.xdoc_planning.forEach((project: any) => {
        project.config.delivery = deliveryType
      })
    }
  }

  screenForm(form: any) {
    const keys = Object.keys(form)
    const defaultKeys = Object.keys(this.defaultForm)
    const screenkeys = keys.filter(item => defaultKeys.includes(item))
    const screenForm: any = {}
    screenkeys.forEach(item => {
      screenForm[item] = form[item]
    })
    return screenForm
  }
}
